import * as $ from "jquery";
import {
  resolveStringToWindowObject
} from './utility';

import onThrottled from '../../utils/event';

const randomString = (l: number) => {
  let s = "";
  while (s.length < l && l > 0) {
    const r = Math.random();
    s += (r < 0.1 ? Math.floor(r * 100) : String.fromCharCode(Math.floor(r * 26) + (r > 0.5 ? 97 : 65)));
  }
  return s;
};

export default class Modal {
  aboveClass = "above";

  supports = {
    flexBox() {
      return (
        "flexWrap" in document.documentElement.style ||
        "webkitFlexWrap" in document.documentElement.style
      );
    },
    history() {
      return window.history && window.history.pushState;
    },
    svg() {
      return document.implementation.hasFeature(
        "http://www.w3.org/TR/SVG11/feature#Image",
        "1.1"
      );
    },
    backgroundSize() {
      return "backgroundSize" in document.documentElement.style;
    },
    touch() {
      return "ontouchstart" in window;
    },
    placeholder() {
      var i = document.createElement("input");
      return "placeholder" in i;
    },
    localStorage() {
      // Bugfix WTF-15606, try/catch for localStorage empty object (private browsers)
      try {
        window.localStorage.setItem("hasStorage", "1");
        return (
          window.localStorage &&
          // @ts-ignore
          window.localStorage.setItem &&
          window.localStorage.removeItem
        );
      } catch (error) {
        return false;
      }
    },
    transitions() {
      var b = document.body || document.documentElement,
        s = b.style,
        p = "transition";

      if (typeof s[p] == "string") {
        return true;
      }

      // Tests for vendor specific prop
      var v = ["Moz", "webkit", "Webkit", "Khtml", "O", "ms"];
      p = p.charAt(0).toUpperCase() + p.substr(1);

      for (var i = 0; i < v.length; i++) {
        if (typeof s[v[i] + p] == "string") {
          return true;
        }
      }

      return false;
    }
  };
  params: any;
  $overlay?: JQuery<HTMLElement>;
  $overlayContainer: any;
  $modal?: JQuery<HTMLElement>;
  $modalHeader?: JQuery<HTMLElement>;
  $modalContent?: JQuery<HTMLElement>;
  $closeLink?: JQuery<HTMLElement>;
  isVisible: any;
  inserted: any;

  constructor(params: any) {
    this.params = {
      // define default params here
      modalType: "dialog",
      centerVertically: true,
      modalContainer: document.body,
      fixed: true,
      id: randomString(8),
      contentClickToHide: true,
      ...params,
    };

    this.init();
    return this;
  }

  init() {
    this.$overlay = this.build();
    this.$overlayContainer = this.params.fixed ? $(window) : this.$overlay.parent();
    this.$modal = $(".modal", this.$overlay).addClass(this.params.modalType);
    this.$modalHeader = $(".modal-header", this.$modal);
    this.$modalContent = $(".modal-content", this.$modal);
    this.$closeLink = $(".close", this.$modal);
  }

  
  centerModal() {
    var self = this;
    this.$modal?.css({
      margin: "0 auto",
      top() {
        return Math.max((self.$overlayContainer.outerHeight() - $(this).outerHeight()) / 2, 0);
      }
    });
  }

  bindModalEvents() {
    onThrottled($(window), "resize." + this.params.id, $.proxy(function () {
      this.place();
    }, this));

    onThrottled($(window), "scroll." + this.params.id, $.proxy(function () {
      this.place();
    }, this));

    $(document).on("keyup." + this.params.id, $.proxy(function (e) {
      if (e.which === 27) {
        this.hide();
      }
    }, this));

    this.$overlay.on("click." + this.params.id, $.proxy(function (e) {
      if (this.isVisible) {

        // Allow parameter to hide modal on modal content click (pre-existing behavior)
        var isContentClick = $(e.target).closest('.modal-content').length;

        if (this.params.contentClickToHide || (!this.params.contentClickToHide && !isContentClick)) {
          this.hide();
        }
      }
    }, this));

    this.$modal?.on("click", "[data-dismiss='modal']", $.proxy(function (e) {
      e.preventDefault();
      this.hide();
    }, this));

    $(document).on("modal.shown", function () {
      setTimeout(function () {
        this.$closeLink.focus();
      }.bind(this), 100);
    }.bind(this));

    $("iframe, img", this.$modal).on("load", function (e) {
      if ($(e.currentTarget).is("iframe")) {
        setTimeout(this.place.bind(this), 100);
      } else {
        this.place();
      }
    }.bind(this));
  }

  unbindModalEvents() {
    $(window).off("resize." + this.params.id);
    $(document).off("keyup." + this.params.id);
  }

  build() {
    const markup = `
      <div class="overlay" data-foo="bar">
        <div class="modal" tabindex="-1" role="dialog" aria-labelledby="modal-header">
          <a href="#" class="close aui-icon aui-icon-large aui-iconfont-remove-label" data-dismiss="modal" title="Close overlay (escape key)"></a>
          <div class="modal-header" id="modal-header"></div>
          <div class="modal-content"></div>
        </div>
      </div>
    `;

    const $overlay = $(markup);
    $overlay.attr('id', this.params.id);

    return $overlay;
  }

  show() {
    if (!this.isVisible) {
      $(this.params.modalContainer).addClass("modal-open");
      this.insert();
      this.$overlay?.addClass("in").trigger("modal.show").delay(200).trigger("modal.shown");
      this.isVisible = true;
      this.place();

      // Initialize the components inside the modal
      this.coreInit(this.$modal);
    }
  }

  hide() {
    if (this.isVisible) {
      this.$overlay?.removeClass("in").trigger("modal.hide").delay(200).trigger("modal.hidden");
      this.isVisible = false;
      $(this.params.modalContainer).removeClass("modal-open");
    }
  }

  place() {
    var unFilledImages = this.$modal[0].querySelectorAll("img[data-src]");
    for (var i = 0; i < unFilledImages.length; i++) {
      unFilledImages[i].src = unFilledImages[i].getAttribute('data-src');
      unFilledImages[i].removeAttribute('data-src');
    }

    var closeLinkIsOutOfBounds,
      isRoomForCloseLink;

    if (this.params.fixed) {
      this.$overlay?.css({
        width: $(window).width(),
        height: window.innerHeight ? window.innerHeight : $(window).height()
      });
    }

    if (this.params.centerVertically) {
      this.centerModal();
    }

    // moves the close link around based on the available space
    closeLinkIsOutOfBounds = this.$closeLink.offset().left + this.$closeLink.outerWidth() > this.$overlay.offset().left + this.$overlay.outerWidth();
    isRoomForCloseLink = this.$overlay.outerWidth() - (this.$modal.offset().left + this.$modal.outerWidth()) > this.$closeLink.outerWidth();

    if (!this.$closeLink.hasClass(this.aboveClass) && closeLinkIsOutOfBounds) {
      this.$closeLink.addClass(this.aboveClass);
    } else if (isRoomForCloseLink) {
      this.$closeLink.removeClass(this.aboveClass);
    }

    this.$overlay.trigger("modal.place");

  }

  insert() {
    if (!this.inserted) {
      this.$overlay?.appendTo(this.params.modalContainer).trigger("modal.insert");
      this.bindModalEvents();
      this.inserted = true;
    }
  }

  remove() {
    this.$overlay?.trigger("modal.remove").remove();
    this.unbindModalEvents();
    this.inserted = false;
  }

  featureDetect() {
    var bodyClasses = [];
    if (!this.supports.svg()) {
      bodyClasses.push("no-svg");
    }
    if (!this.supports.backgroundSize()) {
      bodyClasses.push("no-backgroundsize");
    }
    if (!this.supports.flexBox()) {
      bodyClasses.push("no-flexbox");
    }
    $("body").addClass(bodyClasses.join(" "));
  }

  componentInit(componentRoot, componentInfo) {
    var componentType = resolveStringToWindowObject(componentInfo.type);
    if (componentType) {
      return new componentType(
        componentRoot,
        { ...componentInfo.params, ...$(componentRoot).data() }
      );
    } else {
      // could not find component
    }
  }

  coreInit(domRoot: HTMLElement) {
    var self = this;

    this.featureDetect();

    $("script[type='text/x-component']", domRoot).each(function (i, elem) {
      var componentInfo = $.parseJSON($.trim(elem.innerHTML)),
        componentRoot = elem.parentNode;

      try {
        self.componentInit.call(self, componentRoot, componentInfo);
      } catch (e) {
        console.log(e);
      }
    });

    // Init component scripts with Smartling Translation
    $("script[type='text/x-component-translate']", domRoot).each(function (
      i,
      elem
    ) {
      var innerHTML = $.trim(elem.innerHTML)
        .replace("/* <sl:translate_json> */", "")
        .replace("/* </sl:translate_json> */", "");
      var componentInfo = $.parseJSON(innerHTML),
        componentRoot = elem.parentNode;
      self.componentInit.call(self, componentRoot, componentInfo);
    });
  }
}
